import { useCallback, useEffect, useState } from 'react';

import useCarousel, { EmblaCarouselType } from 'embla-carousel-react';

import { Title } from '@components/Title';

import { TestimonialsCloudAvatars } from './TestimonialsCloudAvatars';
import { TestimonialsCloudItem } from './TestimonialsCloudItem';

interface TestimonialProps {
  title?: Title;
  data: Testimonial[];
}

export const TestimonialsCloud: React.FC<TestimonialProps> = ({
  title,
  data,
}) => {
  const [ref, api] = useCarousel({ loop: true, duration: 45, skipSnaps: true });
  const [selectedIndex, setSelectedIndex] = useState(
    data?.length > 1 ? Math.round(data?.length / 2) - 1 : 0,
  );

  const onInit = useCallback(() => {
    scrollTo(selectedIndex);
  }, [api]);

  const onSelect = useCallback(
    (api: EmblaCarouselType) => {
      setSelectedIndex(api.selectedScrollSnap());
    },
    [api],
  );
  const scrollTo = useCallback(
    (index: number) => api && api.scrollTo(index),
    [api],
  );

  useEffect(() => {
    if (!api) return;

    onInit();
    onSelect(api);
    api.on('reInit', onInit);
    api.on('reInit', onSelect);
    api.on('select', onSelect);
  }, [api, onInit, onSelect]);

  return (
    <div className="flex flex-col items-center justify-center gap-6">
      {title && <Title variant="center" data={title} />}

      <div className="flex pt-4">
        <div ref={ref} className="overflow-hidden">
          <div className="flex max-w-[100vw] items-center">
            {data?.map((item, index) => (
              <TestimonialsCloudItem key={index} data={item} />
            ))}
          </div>
        </div>
      </div>

      <TestimonialsCloudAvatars
        data={data}
        selected={selectedIndex}
        onClick={scrollTo}
      />
    </div>
  );
};
